import React, { useEffect, useState } from 'react'
import { useParams } from 'react-router'

import { RootStateOrAny, useDispatch, useSelector } from 'react-redux'
import { SearchSpecifyJobAction } from '../../redux/actions/job'
import * as types from '../../redux/constantes/job'

import { ContainerContent, ContainerTemplate } from '../../components/Containers'
import { MessageBoxAlert, MessageBoxError } from '../../components/MessageBox'
import { WrapperButtonsModal } from '../../components/Modal/style'
import { ButtonSend } from '../../components/ButtonSend'
import { Header } from '../../components/Header'
import { Wrapper } from '../../components/Wrapper'
import { ButtonRedirect } from '../../components/ButtonRedirect'
import { ViewLabel } from '../../components/ViewLabel'
import { Modal } from '../../components/Modal'

export const TemplateViewJob: React.FC = () => {
  const { id } = useParams<{ id: string }>()

  const [office, setOffice] = useState('')
  const [place, setPlace] = useState('')
  const [area, setArea] = useState<string>()
  const [modality, setModality] = useState<string>()
  const [salary, setSalary] = useState('')
  const [description, setDescription] = useState('')
  const [activities, setActivities] = useState('')
  const [requirements, setRequirements] = useState('')
  const [benefits, setBenefits] = useState('')

  const [question1, setQuestion1] = useState('')
  const [question2, setQuestion2] = useState('')

  const [activeQuestionSalary, setActiveQuestionSalary] = useState(false)

  const [activeModal, setActiveModal] = useState(false)

  const {
    loading: searchSpecifyJobLoading,
    searchSpecifyJob,
    error: searchSpecifyJobError
  } = useSelector((state: RootStateOrAny) => state.searchSpecifyJob)
  const dispatch = useDispatch()

  useEffect(() => {
    if (!searchSpecifyJob) {
      dispatch(SearchSpecifyJobAction(id))
    } else {
      setOffice(searchSpecifyJob.job.Cargo)
      setPlace(searchSpecifyJob.job.Local)
      setArea(searchSpecifyJob.job.Area)
      setModality(searchSpecifyJob.job.Modalidade)
      setSalary(searchSpecifyJob.job.Salario)
      setDescription(searchSpecifyJob.job.Descricao)
      setActivities(searchSpecifyJob.job.Atividades)
      setRequirements(searchSpecifyJob.job.Requisitos)
      setBenefits(searchSpecifyJob.job.Beneficios)
      setQuestion1(searchSpecifyJob.job.QuestionOne && searchSpecifyJob.job.QuestionOne)
      setQuestion2(searchSpecifyJob.job.QuestionTwo && searchSpecifyJob.job.QuestionTwo)
      setActiveQuestionSalary(searchSpecifyJob.job.QuestionThree && searchSpecifyJob.job.QuestionThree.length > 0)
    }
  }, [dispatch, id, searchSpecifyJob])

  useEffect(() => {
    if (searchSpecifyJobError) {
      setTimeout(() => {
        dispatch({ type: types.SEARCH_SPECIFY_JOB_RESET })
      }, 5000)
    }
  }, [searchSpecifyJobError])

  return (
    <ContainerTemplate>
      <Header text="Detalhes da Vaga" />
      <ContainerContent>
        <Wrapper>
          <ViewLabel label="Cargo" value={office} widthDiv="74%" />
          <ViewLabel label="Local" value={place} widthDiv="24%" />
        </Wrapper>
        <Wrapper>
          <ViewLabel label="Área" value={area as string} widthDiv="36%" />
          <ViewLabel label="Modalidade" value={modality as string} widthDiv="36%" />
          <ViewLabel label="Salário" value={salary} widthDiv="24%" />
        </Wrapper>
        <Wrapper>
          <ViewLabel typeView="large" label="Descrição" value={description} widthDiv="49%" heightDiv="large" />
          <ViewLabel typeView="large" label="Atividades" value={activities} widthDiv="49%" heightDiv="large" />
        </Wrapper>
        <Wrapper>
          <ViewLabel typeView="large" label="Requisitos" value={requirements} widthDiv="49%" heightDiv="large" />
          <ViewLabel typeView="large" label="Benefícios" value={benefits} widthDiv="49%" heightDiv="large" />
        </Wrapper>

        {activeModal && (
          <Modal
            setActiveModal={setActiveModal}
            office={office}
            question1={question1}
            question2={question2}
            activeQuestionSalary={activeQuestionSalary}
          />
        )}

        <WrapperButtonsModal>
          <ButtonRedirect nameButton="Voltar" link="/" />
          <ButtonSend color="success" nameButton="Tenho Interesse" onClick={() => setActiveModal(true)} />
        </WrapperButtonsModal>

        {searchSpecifyJobLoading && <MessageBoxAlert>Carregando...</MessageBoxAlert>}
        {searchSpecifyJobError && <MessageBoxError>{searchSpecifyJobError}</MessageBoxError>}
      </ContainerContent>
    </ContainerTemplate>
  )
}
